<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<sf-select-group
						:label="getMessage_('SWCC000015')"
						:inputValue="plantCd"
						:options="plants"
						:onChange="value => onChange({ name: 'plantCd', value: value })"
					/>
				</el-col>
				<el-col :span="3">
					<sf-select-group
						label="Queue Type"
						:inputValue="queueType"
						:options="queueTypes"
						:onChange="value => onChange({ name: 'queueType', value: value })"
					/>
				</el-col>
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('SWCC000361')">
						<el-checkbox :value="remained" @change="value => onChange({ name: 'remained', value: value })"></el-checkbox>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button v-if="isButton_(scrId, 'CR')" line icon="search" :onClick="this.onSearch">{{ getMessage_('SWCC000008') }}</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/QueueRecordCount/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onSearch() {
			this.$sf_toggleLoading(true);
			this.getQueueRecordCountList_()
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onChange({ name, value }) {
			this.changeValue_({ name: name, value: value });
			if (name == 'plantCd') {
				this.getCommCds_({ commCdType: 'QTYPE', commCdList: 'queueTypes', option: 'All' });
				this.changeValue_({ name: 'queueTypes', value: 'All' });
			}
			this.onSearch();
		}
	},
	created() {
		this.getPlant_();
		this.changeValue_({ name: 'plantCd', value: this.user.plantCd });
		this.getCommCds_({ commCdType: 'QTYPE', commCdList: 'queueTypes', option: 'All' });
		this.onSearch();
	}
};
</script>
<style></style>
